import pyForm from 'pylon-vue/src/components/form/form';

const sForm = {
    name: 'sForm',
    extends: pyForm,
    props: {
        autocomplete: {
            default: "off"
        }
    }
}

export default sForm